var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.887,
    height: 57.312,
    viewBox: "0 0 46.887 57.312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-650.713 -740.507)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(650.713 740.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M698.388,793.957v13.861a10.138,10.138,0,0,1-10.37,10.339H667.089a10.135,10.135,0,0,1-10.366-10.342V779.351a2.636,2.636,0,0,1,1.459-2.59,2.451,2.451,0,0,1,2.72.251,2.792,2.792,0,0,1,1.047,2.458q-.017,10.417,0,20.838v7.442a4.971,4.971,0,0,0,5.208,5.2h20.838a4.971,4.971,0,0,0,5.205-5.2v-28.28a2.655,2.655,0,0,1,2.319-2.968,2.591,2.591,0,0,1,2.883,2.761V793.4Q698.388,793.678,698.388,793.957Z",
    transform: "translate(-654.091 -760.848)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M663.738,748.329v-4.9a2.621,2.621,0,0,1,2.856-2.907h15.163a2.614,2.614,0,0,1,2.846,2.825V748a1.975,1.975,0,0,0,.065.292c.3,0,.619.041.945.041h9.115a2.615,2.615,0,1,1-.017,5.2H653.593a2.615,2.615,0,1,1,0-5.2h10.145Zm5.263-.078h10.315v-2.458H669Z",
    transform: "translate(-650.713 -740.507)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M691.918,800.214v8.839a2.614,2.614,0,1,1-5.2.021q0-8.84,0-17.679a2.614,2.614,0,1,1,5.2-.021Q691.923,795.8,691.918,800.214Z",
    transform: "translate(-671.067 -767.66)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M715.927,800.265v9.023a2.594,2.594,0,0,1-4.967,1.135,3.362,3.362,0,0,1-.221-1.265q-.02-8.932,0-17.863a2.608,2.608,0,1,1,5.2.034Q715.938,795.8,715.927,800.265Z",
    transform: "translate(-684.652 -767.679)",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.985b9d01796bba18e1cdfa56470d900f.svg";
export { ForwardRef as ReactComponent };